import React from 'react';
import ChooseYourKeyboard from "./chooseYourKeyboard/ChooseYourKeyboard";
import SetKeyboardSize from "./SetKeyboardSize";
import {KeyboardWizardMode, KeyboardWizardPage} from "../../../redux/keyboardWizard/keyboardWizardTypes";
import {keyboardWizardStore} from "../../../redux/keyboardWizard/keyboardWizardStore";
import {useAppSelector} from "../../../redux/hooks";
import InputDetectedFromWrongDevicePrompt
  from "./inputDetectedFromWrongDevicePrompt/InputDetectedFromWrongDevicePrompt";
import KeyboardSetupComplete from "./KeyboardSetupComplete";

interface IKeyboardWizardProps {
  mode: KeyboardWizardMode;
  onStartPlaying: () => void;
}

export default function KeyboardWizard({onStartPlaying, mode}: IKeyboardWizardProps) {
  const currentPage = useAppSelector(keyboardWizardStore.getCurrentPage);

  let Component = null;

  switch (currentPage) {
    case KeyboardWizardPage.ChooseDevice:
      Component = <ChooseYourKeyboard mode={mode} />;
      break;
    case KeyboardWizardPage.SetLowestNote:
    case KeyboardWizardPage.SetHighestNote:
      Component = <SetKeyboardSize mode={mode} />;
      break;
    case KeyboardWizardPage.SetupComplete:
      Component = <KeyboardSetupComplete onStartPlaying={onStartPlaying} mode={mode} isBackButtonShown={true}/>;
      break;
    default:
      throw new Error(`Invalid page: ${currentPage}`);
  }

  return (
    <>
      {Component}
      <InputDetectedFromWrongDevicePrompt />
    </>
  );
}
